export const P00043ModeRegulation = [
  { ref: 0, label: 'P00043.params.regulation.warm' },
  { ref: 1, label: 'P00043.params.regulation.cold' },
];
